module.exports = __webpack_public_path__ + "static/media/file-audio.f2cadf3c.svg";